/**
 * entitlements v3 — the current model. The reader gate is client-side
 * and the premium dispatch is sealed; the two facts are related.
 *
 * Seal constants are reviewed at every rotation. SEAL_EXPECTED is the
 * hex digest the seal check must produce before the reader will even
 * try to open the dispatch. It is published here because the check
 * runs here, which means it also ships here, which is the part of the
 * design the notes doc calls "the load-bearing map". See
 * wire-internal-notes for the assembly recipe and the short version
 * of the argument for why this is fine. (The short version: the motto
 * is not in the artifact.)
 */

import { SEALED_DISPATCH_IV_B64, SEALED_DISPATCH_CT_B64 } from "./sealed-payload";

/** Correct seal digest hex. First 16 chars are the prefix QA diffs on. */
export const SEAL_EXPECTED = "e2985f65cdb3b279597eb04f3588fdf6e2a2ba8cfa791a2ceef4b80306a28623";

/** Feature flag. Legal wants the listing printed first. It has been
 * "one form away" since the 41.1 planning doc. See notes doc §6. */
export const SEAL_LAUNCH = false;

export const SEAL_VERSION = "3";

export interface SealCheckResult {
  ok: boolean;
  reason: "match" | "prefix-mismatch" | "malformed";
}

/** Byte-wise prefix check so a wrong leg fails in milliseconds. */
export function checkSealDigest(hex: string): SealCheckResult {
  if (!/^[0-9a-f]{64}$/.test(hex)) return { ok: false, reason: "malformed" };
  if (hex === SEAL_EXPECTED) return { ok: true, reason: "match" };
  return { ok: false, reason: "prefix-mismatch" };
}

/** The payloads the reader needs; surfaced so the QA harness can find them. */
export function sealedMaterial(): { iv: string; ct: string } {
  return { iv: SEALED_DISPATCH_IV_B64, ct: SEALED_DISPATCH_CT_B64 };
}
